import { Anchor, type _Navigation } from ":shared/components/route";
import { default as routes } from "../routes";
import IdleIcon from "../assets/idle-flag.svg";
import ActiveIcon from "../assets/active-flag.svg";
import { LockedAnchor } from ":src/components/overlays";
import { global } from ":global";
export default function ProjectSubmission(props: _Navigation.SideNavJSXItemProps) {
  const $settings = global.store.hooks.platform.useSettings("submission");
  return (
    <Anchor
      class={`relative  ${props?.anchor?.class}`}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      events={{
        getShouldNavigate: () => !$settings().locked,
      }}
      triggers={{
        onBeforeNavigate: () => {
          if ($settings().locked) {
            global.store.actions.alert.pushToast({
              type: "error",
              message: "This page is locked by admin, you can't access it right now!",
            });
          }
        },
      }}
      components={{
        title: "Project Submission",
        idleIcon: <IdleIcon />,
        activeIcon: <ActiveIcon />,
      }}
    >
      <LockedAnchor locked={$settings().locked} />
    </Anchor>
  );
}
